<template>
	<v-container>
		<v-card class="mx-auto" max-width="800">
			<v-card-title>Ρυθμίσεις εταιρίας</v-card-title>
			<v-card-text>
				<v-window v-model="step">
					<v-window-item v-bind:value="0">
						<h3 class="text-h6 font-weight-light mb-2">Βασικά στοιχεία</h3>
						<v-text-field label="Επωνυμία" v-model="company.name"></v-text-field>
                        <v-text-field label="Δραστηριότητα" v-model="company.jobtitle"></v-text-field>
						<v-text-field label="ΑΦΜ" v-model="company.tax_registration_number"></v-text-field>
						<v-select label="ΔΟΥ" v-bind:items="taxOffices" v-model="company.tax_registration_office_id" item-text="name" item-value="id"></v-select>
						<v-text-field label="Έδρα" v-model="company.location"></v-text-field>
						<v-text-field label="Διεύθυνση" v-model="company.address"></v-text-field>
						<v-text-field label="Ταχ. Κωδικός" v-model="company.zipcode"></v-text-field>
						<v-text-field label="Τηλέφωνο" v-model="company.telephone"></v-text-field>
						<v-text-field label="Φαξ" v-model="company.fax"></v-text-field>
						<v-text-field label="Αρ. ΓΕΜΗ" v-model="company.trade_registry_number"></v-text-field>
					</v-window-item>
					<v-window-item v-bind:value="1">
						<h3 class="text-h6 font-weight-light mb-2">Στοιχεία ΑΑΔΕ</h3>
						
						<v-text-field label="Όνομα χρήστη μητρώου ΑΦΜ" v-model="company.tax_authority_registry_username"></v-text-field>
						<v-text-field label="Κωδικός μητρώου ΑΦΜ" v-model="company.tax_authority_registry_password"></v-text-field>
						
						<v-text-field label="Όνομα χρήστη myData" v-model="company.tax_authority_mydata_username"></v-text-field>
						<v-text-field label="Subscription Key myData" v-model="company.tax_authority_mydata_subscription_key"></v-text-field>

						<v-checkbox label="Ενημέρωση myData κατά την έκδοση" v-model="company.tax_authority_mydata_auto_upload"></v-checkbox>
					</v-window-item>

					<v-window-item v-bind:value="2">
						<h3 class="text-h6 font-weight-light mb-2">Στοιχεία email</h3>
						
						<v-text-field label="hostname" v-model="company.smtp_hostname"></v-text-field>
						<v-text-field label="port" type="number" v-model.number="company.smtp_port"></v-text-field>
						<v-text-field label="username" v-model="company.smtp_username"></v-text-field>
						<v-text-field label="password" v-model="company.smtp_password"></v-text-field>
						<v-text-field label="mailbox" v-model="company.smtp_mailbox"></v-text-field>
						
					</v-window-item>


					<v-window-item v-bind:value="3">
						<h3 class="text-h6 font-weight-light mb-2">Λοιπά στοιχεία email</h3>
						
						<file-uploader title="Λογότυπο παραστατικών" filter="image/*" target="api/company/logo2"/>
					</v-window-item>

					<v-window-item v-bind:value="4">
						<h3 class="text-h6 font-weight-light mb-2">Τραπεζικοί Λογαριασμοί</h3>
                        <v-btn text color="primary" @click="addBankAccount" :disabled="company.bank_accounts && company.bank_accounts.length >= 4">ΠΡΟΣΘΗΚΗ ΛΟΓΑΡΙΑΣΜΟΥ</v-btn>
						
                        <v-data-table
                            :headers="bankAccountHeaders"
                            :items="company.bank_accounts"
                            :loading="loading"
                            loading-text="Φόρτωση τραπεζικών λογαριασμών..."
                            no-data-text="Δεν υπάρχουν τραπεζικοί λογαριασμοί"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                            class="elevation-1"
                            dense
                        >
                            <template v-slot:[`item.bank_name_gr`]="{ item }">
                                <v-text-field v-model="item.bank_name_gr" dense hide-details single-line placeholder="π.χ. ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ"></v-text-field>
                            </template>
                            <template v-slot:[`item.bank_name_en`]="{ item }">
                                <v-text-field v-model="item.bank_name_en" dense hide-details single-line placeholder="e.g. NATIONAL BANK"></v-text-field>
                            </template>
                            <template v-slot:[`item.account_number`]="{ item }">
                                <v-text-field v-model="item.account_number" dense hide-details single-line placeholder="π.χ. GR1234..."></v-text-field>
                            </template>
                            <template v-slot:[`item.actions`]="{ index }">
                                <v-icon small color="error" @click="removeBankAccount(index)">mdi-delete</v-icon>
                            </template>
                        </v-data-table>

						<div class="text-center">
							<v-btn class="mb-4 mt-4" color="success" v-bind:loading="saveButtonDisabled" @click="save">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
						</div>
					</v-window-item>

				</v-window>
			</v-card-text>
			<v-card-actions>
                <v-btn
					v-bind:disabled="step <= 0"
    	              text
        	          v-on:click="step--"
            	      color="primary">
                	  ΠΙΣΩ
                </v-btn>
                <v-spacer></v-spacer>
                
				<v-item-group
					v-model="step"
                  	class="text-center"
                  	mandatory>
                  	<v-item
						v-for="n in totalSteps"
						:key="`btn-${n}`"
						v-slot="{ active, toggle }">
				
						<v-btn v-bind:input-value="active" icon @click="toggle">
							<v-icon>mdi-record</v-icon>
						</v-btn>
					</v-item>
				</v-item-group>
                
                <v-spacer></v-spacer>
                <v-btn
                  	v-bind:disabled="step >= totalSteps - 1"
                  	color="primary"
                  	depressed
                  	@click="step++">
					ΕΠΟΜΕΝΟ
                </v-btn>
			</v-card-actions>
		</v-card>		
	</v-container>
</template>


<script>
import LoginForm from '../LoginForm.vue';
export default {
  	components: { LoginForm },
	data: () => ({
		loading: true,
	
    	step: 0,
		totalSteps: 5,
		taxOffices: [],
		company: {
            bank_accounts: []
        },
        bankAccountHeaders: [
            { text: 'Τράπεζα (GR)', value: 'bank_name_gr', width: '30%' },
            { text: 'Τράπεζα (EN)', value: 'bank_name_en', width: '30%' },
            { text: 'IBAN / Αρ. Λογαριασμού', value: 'account_number', width: '35%' },
            { text: '', value: 'actions', sortable: false, width: '5%' },
        ],
		saveButtonDisabled: false
	}),

	created() {
		this.initialize()
	},

	methods: {
		initialize() {
			this.loading = true;
			axios.get("/api/company")
			.then(response => {
                this.company = response.data
                if (!this.company.bank_accounts) this.company.bank_accounts = [];
            }).catch(e => console.error(e)).finally(() => { this.loading = false; })
			// .catch(error => console.log(error))

			axios.get("/api/tax-offices")
			.then(response => this.taxOffices = response.data)
			// .catch(error => console.log(error))
		},

        addBankAccount() {
            if (!this.company.bank_accounts) this.company.bank_accounts = [];
            if (this.company.bank_accounts.length < 4) {
                this.company.bank_accounts.push({
                    bank_name_gr: '',
                    bank_name_en: '',
                    account_number: ''
                });
            }
        },

        removeBankAccount(index) {
            this.company.bank_accounts.splice(index, 1);
        },

		save() {
			this.saveButtonDisabled = true;

			let requestBody = {
				name: this.company.name,
                jobtitle: this.company.jobtitle,
				tax_registration_number: this.company.tax_registration_number,
				tax_registration_office_id: this.company.tax_registration_office_id,
				location: this.company.location,
				address: this.company.address,
				zipcode: this.company.zipcode,
				telephone: this.company.telephone,
				fax: this.company.fax,

				smtp_hostname: this.company.smtp_hostname,
				smtp_port: this.company.smtp_port,
				smtp_username: this.company.smtp_username,
				smtp_password: this.company.smtp_password,
				smtp_mailbox: this.company.smtp_mailbox,
				smtp_encryption: this.company.smtp_encryption,

				tax_authority_registry_username: this.company.tax_authority_registry_username,
				tax_authority_registry_password: this.company.tax_authority_registry_password,

				tax_authority_mydata_auto_upload: this.company.tax_authority_mydata_auto_upload,

				tax_authority_mydata_username: this.company.tax_authority_mydata_username,
				tax_authority_mydata_subscription_key: this.company.tax_authority_mydata_subscription_key,

				trade_registry_number: this.company.trade_registry_number,

                bank_accounts: this.company.bank_accounts
			}

			console.log(requestBody);

			axios.patch('/api/company', requestBody )
			.then(response => { 
                this.company = response.data 
                if (!this.company.bank_accounts) this.company.bank_accounts = [];
            })
			.catch(error => { console.log(error); this.allerrors = error.response.data.errors } )
			.finally(() => { this.saveButtonDisabled = false; })
		}
	}	

};
</script>

<style scoped>
</style>